<template>
    <div class="upload-panel-wrapper col-md-5 p-0">
        <div class="close-or-min-panel">
            <div class="heading">{{$t('TAGS')}}</div>
            <div class="close-icon-wrapper">
                <cancel-icon @click.native="closePanel" class="close-icon mt-1"></cancel-icon>
            </div>
        </div>
        <div class="info-wrapper">
            <div class="normal-text-display">{{$t('Tag is a predefined keyword. Tags are created and used as metadata to content')}}.</div>

            <div class="normal-text-display">
                <div class="sub-header-wrapper"><b class="sub-header">{{$t('Why Tags are used instead of mentioning keyword in description')}}?</b></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">1</div></div><div class="text-for-bullet">{{$t('To reduce typo errors')}}.</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">2</div></div><div class="text-for-bullet">{{$t('To quickly select tags from predefined tag list')}}.</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">3</div></div><div class="text-for-bullet">{{$t('To summarize metadata in few predefined keywords')}}.</div></div>
            </div>

            <div class="tip-div">
                <div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
                        <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>
                      </svg>
                </div>
                <div>
                    <b style="color: #85b5ce;">{{$t('Tip')}}:</b>
                    {{$t('One asset can have multiple tags')}}.
                </div>
            </div>
            </div>
    </div>
</template>

<script>
import cancelIcon from "../core/InlineCancelField.vue"
export default {
    components:{
        'cancel-icon':cancelIcon,
    },
    methods:{
        closePanel(){
            this.$emit("close");
        },
    },
}
</script>

<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$background-color-on-hover: #141414;
$body-background-color: #0d0d0d;
$dull-text-color: #858585;
$options-text-color: #9c9c9c;
$icon-color-on-hover: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$table-border-color:1px solid #141414;
$active-blue: #007bff;
$danger-color: #dc3545 !important;
$input-field-bg-color: #121212;
$input-field-border-color: #202020;
$input-field-height:38px;
$button-height:38px;
$secondary-border-color: 1px solid #3a3a3a;
$searchBar-border-color: 1px solid #202020;
$secondary-text-color: #bbb;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#141414;
$scrollbar-thumb-on-hover-background:#555;
$input-field-padding:.375rem 10px;
$input-field-and-label-font-size:14px;
$danger-color: #dc3545 !important;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$breadcrumb-background:#161616;
$mutliselect-tag-bg-color:#0a0a0a;
$mutliselect-all-tags-bg-color:#161616;
$multiselect-option-highlight-bg-color:#242424;
$multiselect-tag-on-focus-or-hover-bg-color:#3D3D3D;
$overlay-info-panel-bg-color:#1b1b1b;
$overlay-panel-border-color:#272727;
$panel-heading-font-size:24px;
$info-color:rgb(209, 210, 211);
$info-font-size:15px;
$info-sub-header-color:#e8912d;
$info-header-font-size:22px;
$tip-border-color:#23485f;
$tip-background-color:#10202a;
$tip-text-color:#8aa1ad;
$tip-icon-color:#85b5ce;
$bullet-background-color:#295318;
$close-icon-bg-on-hover:#3a3a3a;

.active{
    color:$active-blue;
}

.filters-bar{
    max-height: 100%;
    width: 100%;
    overflow:auto;
    display:inline-block;
    ul{
        list-style-type: none;
        padding-inline-start:2px;
        li{
            text-align: start;
            margin-inline-start: 6%;
            margin-top: 9px;
        }
    }
}
.upload-panel-wrapper{
    border-inline-start: 1px solid $overlay-panel-border-color;
    position: absolute;
    background: $background-color-on-hover;
    bottom: 1px!important;
    top: 12px !important;
    inset-inline-end: 0%;
    z-index: 9;
    max-height: 100%;
    height: 100%;
    box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    -webkit-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    -moz-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    .close-or-min-panel{
            height: 60px;
            width:100%;
            border-bottom: 1px solid $overlay-panel-border-color;
            background: $overlay-info-panel-bg-color;
            text-align: end;
            padding: 12px;
            display: flex;
            justify-content: flex-end;
        }
    .info-wrapper{
            width: 100%;
            padding: 24px;
            overflow:auto;
            display:inline-block;
            height: 85%;
            .edit-upload-info{
                width:8%;
                padding: 5px;
                    svg{
                        position: relative;
                        inset-inline-end: 6px;
                    }
            }
            }
        }



.edit-upload-info{
    position: relative;
    inset-inline-start:0px;
}

.minHeight{
    height:52px !important;
    bottom:1px !important;
    top: unset !important;
}

.upload-bars{
    margin-bottom: 12px;
}

.heading{
    text-align:start;
    width:94%;
    padding:2px;
    font-size:$panel-heading-font-size;
}

.normal-text-display{
    text-align: start;
    margin-bottom: 10px;
    color:$info-color;
    font-size:$info-font-size;
}

.sub-header{
    color: $info-sub-header-color;
    font-weight: 100;
    font-size:$info-header-font-size
}

.sub-header-wrapper{
    margin:25px 0px 5px 0px;
}

.tip-div{
    width: 100%;
    height: auto;
    display:inline-flex;
    padding: 12px;
    text-align: start;
    border: 1px solid $tip-border-color;
    background: $tip-background-color;
    border-radius: 5px;
    margin: 20px 0;
    color: $tip-text-color;
    svg{
        margin: 0px 14px 0px 0px;
        color: $tip-icon-color;
    }
}

.text-with-bullets-wrapper{
    display:inline-flex;
    margin-bottom: 10px;
    .bullets-wrapper{
        .bullets{
            height: 23px;
            width: 23px;
            border-radius: 8px;
            background: $bullet-background-color;
            margin: 0 auto;
            padding-inline-start: 7px;
            padding-top: 1px;
            margin: 3px 14px 0px 5px;
        }
    }
    .text-for-bullet{
        padding-top:4px;
    }
}

.image-wrapper{
    height: auto;
    width: 250px;
    margin: 20px auto;
}

.close-icon-wrapper{
    position: relative;
    bottom: 1px;
    .close-icon{
        height: 30px !important;
        width: 30px !important;
        color: $dull-text-color !important;
    }
}

.close-icon:hover{
  background: $close-icon-bg-on-hover;
  border-radius: 20px;
}
</style>



